module.exports = __webpack_public_path__ + "img/level_five_lock.2fe14dcc.png";